export enum MFAType {
  None = 'None',
  SMS = 'SMS',
  Unknown = 'Unknown',
  Unsupported = 'Unsupported',
}
